import React from "react";
import { Link } from "react-router-dom";
import { IconType } from "react-icons";
import {
  MdArrowForward,
  MdOutlineNoteAdd,
  MdOutlinePersonAddAlt,
  MdOutlineSend,
  MdOutlineChat,
} from "react-icons/md";
import { TbBroadcast } from "react-icons/tb";

const ACTIONS: { title: string; text: string; to: string; Icon: IconType; tone: string }[] = [
  {
    title: "Send a message",
    text: "Reach a customer on WhatsApp right away.",
    to: "/admin/variables-send-message/single",
    Icon: MdOutlineSend,
    tone: "bg-blue-50 text-blue-600",
  },
  {
    title: "Start a broadcast",
    text: "Send one template to many contacts.",
    to: "/admin/variables-send-message/broadcast",
    Icon: TbBroadcast,
    tone: "bg-violet-50 text-violet-600",
  },
  {
    title: "Create a template",
    text: "Design a new WhatsApp message template.",
    to: "/admin/templates/add",
    Icon: MdOutlineNoteAdd,
    tone: "bg-emerald-50 text-emerald-600",
  },
  {
    title: "Add a customer",
    text: "Save a contact so you can message them.",
    to: "/admin/customers/add",
    Icon: MdOutlinePersonAddAlt,
    tone: "bg-amber-50 text-amber-600",
  },
  {
    title: "Open live chat",
    text: "Reply to customer conversations.",
    to: "/admin/live-chat",
    Icon: MdOutlineChat,
    tone: "bg-teal-50 text-teal-600",
  },
];

export default function ActionPanel() {
  return (
    <div className="bg-white rounded-3xl border border-app-line shadow-card p-5 sm:p-6">
      <h3 className="text-[15px] font-semibold text-app-ink">Quick actions</h3>
      <p className="text-[12.5px] text-app-muted mt-0.5">Jump straight into the most common tasks.</p>

      <div className="mt-4 -mx-2 space-y-0.5">
        {ACTIONS.map(({ title, text, to, Icon, tone }) => (
          <Link
            key={title}
            to={to}
            className="group flex items-center gap-3.5 p-2.5 rounded-2xl hover:bg-app-bg transition-colors"
          >
            <span className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${tone}`}>
              <Icon size={19} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-[13.5px] font-semibold text-app-ink">{title}</span>
              <span className="block text-[12px] text-app-muted truncate">{text}</span>
            </span>
            <MdArrowForward className="text-slate-300 group-hover:text-brand-main group-hover:translate-x-0.5 transition" />
          </Link>
        ))}
      </div>
    </div>
  );
}
